import { mapFirstPerson } from '../DataTypes/personMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

//TODO: Add props interface
export const mapArticlePageProperties = async (
	properties,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.ArticlePageProperties> => {
	try {
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			kicker: properties.kicker,
			heading: properties.heading,
			teaser: properties.teaser,
			author: mapFirstPerson(properties.author),
		};
	} catch (e) {
		logger.error('Could not map ArticlePage Properties', e);
		throw new Error('Could not map ArticlePage Properties', e);
	}
};
